export const CONTENTFUL_MODULE_NAME = 'contentful';
